import { render, staticRenderFns } from "./MCQ.vue?vue&type=template&id=51d7b46a&scoped=true&"
import script from "./MCQ.vue?vue&type=script&lang=js&"
export * from "./MCQ.vue?vue&type=script&lang=js&"
import style0 from "./MCQ.vue?vue&type=style&index=0&id=51d7b46a&scoped=true&lang=css&"
import style1 from "./MCQ.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d7b46a",
  null
  
)

export default component.exports